import { dirMtxApply, dirMtxInverse, dirMtxProductImpl } from "./DirMtx";
import { reverseSide } from "./Side";
const lookupMaps = [...Array(8)].map((i) => {
    return new WeakMap();
});
export class TileView {
    static lookup(tile, orientation) {
        return tile.tileViews[orientation];
        // const map = lookupMaps[orientation];
        // if(!map.has(tile)){
        //     const view = new TileView(tile, orientation);
        //     map.set(tile, view);
        //     return view;
        // }
        // return map.get(tile);
    }
    constructor(tile, orientation) {
        this.tile = tile;
        this.orientation = orientation;
        this.id = `${tile.id},${orientation}`;
    }
    computeSide(i) {
        return dirMtxApply(dirMtxInverse(this.orientation), i);
    }
    getNeighbor(i) {
        const edge = this.tile.getReference(this.computeSide(i));
        if (edge) {
            return TileView.lookup(edge.to, dirMtxProductImpl(this.orientation, edge.mtx));
        }
        return null;
    }
    stepOn(t) {
        this.tile.stepOn(t);
    }
    interact(t) {
        this.tile.interact(t);
    }
    track(entity) {
        this.tile.track(entity);
    }
    link(fromSide, toTile, toSide = reverseSide(fromSide), { reflect = false, addReverse = true } = {}) {
        this.tile.link(this.computeSide(fromSide), toTile.tile, toTile.computeSide(toSide), {
            reflect: !reflect !== !((toTile.orientation ^ this.orientation) & 0b100),
            addReverse
        });
    }
    rotate(mtx) {
        return this.tile.getView(dirMtxProductImpl(mtx, this.orientation));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/TileView.ts
// module id = 16
// module chunks = 0